import { getData, getDataIx0 } from "./../../services/library"
import { UrlApi } from "./../../services/apirest"
import { getUserBranchesFilter } from "../../utils/filters";

export const fetchClientesByEmpresa = (texto, setClientes, aUsuario, setCargando, setNoOptionsText, sucAuth, isControlador, idEmpresa) => {
    const esGenerico = aUsuario ? 1 : 0;
    setCargando(true);
    const sucursales = getUserBranchesFilter();
    const ruta = `${UrlApi}/allClientes/alta-remitos/${sucursales}/${idEmpresa}/search?q=${encodeURIComponent(texto)}&esGenerico=${esGenerico}`
    
    fetch(ruta)
        .then((res) => res.json())
        .then((data) => {
            setClientes(data);
            if (data.length === 0) {
                setNoOptionsText("No se encontraron clientes.");
            }
        })
        .catch((err) => {
            console.error("Error fetch clientes:", err);
            setClientes([]);
        })
        .finally(() => setCargando(false));
};

export function getRemitos(setRemitos) {
    const sucursales = getUserBranchesFilter();
    getData(`/remitos/by-suc?sucursales=${encodeURIComponent(sucursales)}`, setRemitos);
}

export function getParamsNegocios(setParamsNegocios) {
    getData("/parametrosPorNegocio", setParamsNegocios);
}

export function getEmpresas(setEmpresas) {
    getData("/empresas/facturadoras", setEmpresas);
}

export function getSucursales(setSucursales) {
    getData("/sucursales", setSucursales);
}

export function getSucursalesEmpresa(idEmpresa, setSucursales) {
    getData(`/sucursales/empresayotra/${idEmpresa}`, setSucursales);
}

export function getChoferes(idSuc, setChoferes) {
    getData(`/choferes/by-suc/${idSuc}`, setChoferes); 
}

export async function enviarRemito({
    dataRemito,
    itemsRemito,
    clienteSeleccionado,
    direccionSeleccionada,
    setToast
}) {

    const enviar = {
        ...dataRemito,
        nro: `${dataRemito.puntoVenta}-${dataRemito.nroComprobante}`,
        id_cliente: clienteSeleccionado.id,
        id_direccion_entrega: direccionSeleccionada.id,
        id_tipo_cliente: clienteSeleccionado.id_negocio_cliente,
        itemsRemito
    }
    delete enviar.puntoVenta;
    delete enviar.nroComprobante;

    try {
        const res = await fetch(
            `${UrlApi}/remitos/remitos-items`
            , {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(enviar),
            }
        )
        if(res.ok){
            setToast({
                severity:"success",
                msg:"Remito Guardado Exitosamente!"
            })
        } else {
            setToast({
                severity:"error",
                msg:"Error al guardar el remito."
            })
        }
    } catch (error) {
        alert(error)
    }

}

export const obtenerProductos = async (
    // usos, 
    setProductos
    ) => {
    const usos = [249,250]
    const response = await fetch(UrlApi + `/productos/id_uso/${usos}`) //Esta es la ruta que se debe usar realmente, usamos la de abajo porque de momento es solo para propelente.
    // const response = await fetch(UrlApi + `/productos/propelente`) 
    const data = await response.json()
    setProductos(data)
}

export const getItemsRemito = async (idRemito, setItems) => {
    const response = await fetch(UrlApi + `/remitos_items/id-remito/${idRemito}`)
    const data = await response.json()
    setItems(data)
}

export async function fetchParamsNegocio(setParamsNegocios) {
    const res = await fetch(`${UrlApi}/parametrosPorNegocio`)
    const data = await res.json();
    return data;
}

export const putRemitos = async (remito, showToast) => {
    const ruta = `${UrlApi}/remitos/${remito.id_remito}`
    const response = await fetch(ruta, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_estado: 3 })
    })
    if (response.ok) {
        showToast("Remito Anulado exitosamente!", "success")
    }

}

//jaja, mejorar esto
export const getClienteSeleccionado= async (tipoCli, idCli, setClienteSelected) => {
    if(tipoCli == 1 || tipoCli == 2  ){
        getDataIx0(`/clientes/by-id/${idCli}`, setClienteSelected);
    }
    if(tipoCli == 3){
        getDataIx0(`/envasado_clientes/xid/${idCli}`, setClienteSelected);
    }
    
}

export const getItems= async (idRemito, setItems) => {
    getData(`/remitos/items/${idRemito}`, setItems)
}


export const fetchItemsRem = async (idRemito, setItems) => {
    const response = await fetch(UrlApi + `/remitos_items/id-remito/${idRemito}`)
    const data = await response.json()
    return data;
}

export const fetchNroRemito = async (remito) => {
    const nro = `${(remito.puntoVenta).padStart(4, '0')}-${(remito.nroComprobante).padStart(8, '0')}`;
    const response = await fetch(UrlApi + `/remitos/by-nro/${nro}`)
    const data = await response.json()
    return data;
}



export async function editarRemito({
    dataRemito,
    itemsRemito,
    itemsEliminar,
    clienteSeleccionado,
    direccionSeleccionada,
    setNotify,
    getRemitos,
    setOpenDialog,
    setDisBtn
}) {

    const enviar = {
        ...dataRemito,
        nro: `${dataRemito.puntoVenta}-${dataRemito.nroComprobante}`,
        id_cliente: clienteSeleccionado.id,
        id_direccion_entrega: direccionSeleccionada.id,
        id_tipo_cliente: clienteSeleccionado.id_negocio_cliente,
        itemsRemito,
        itemsEliminar
    }

    delete enviar.puntoVenta;
    delete enviar.nroComprobante;

    try {
        const res = await fetch(
            `${UrlApi}/remitos/remitos-items-updt`
            , {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(enviar),
            }
        )

        if (res.ok) {
            setNotify({
                open: true,
                severity: "success",
                mensaje: "Remito modificado exitosamente!",
                handleClose: () => {
                    getRemitos();
                    setNotify({ open: false })
                    setOpenDialog(false)
                }
            })
        }

        const err = await res?.json();
        if (err.error) {
            setNotify({
                open: true,
                severity: "error",
                mensaje: `${err.error}`,
                handleClose: () => {
                    getRemitos();
                    setNotify({ open: false })
                    setDisBtn(false)
                }
            })
        }
    } catch (error) {
        setNotify({
            open: true,
            severity: "error",
            mensaje: `${error.error}`,
            handleClose: () => {
                getRemitos();
                setNotify({ open: false })
                setDisBtn(false)
            }
            
        })
    }

}
